<div class="login-container">
  <div class="logo-container">
    <img
      src="assets/img/RiberaSalud_Sin_Fondo_Palabra.png"
      alt="Ribera Salud"
      class="login-logo"
    />
    <span *ngIf="mostrarEntorno" class="entorno-badge">{{ entorno }}</span>
  </div>
  <h3>INICIAR SESIÓN</h3>
  <form (ngSubmit)="iniciarSesion()">
    <div>
      <label for="username">Usuario:</label>
      <input
        type="text"
        name="nombreUsuario"
        [(ngModel)]="nombreUsuario"
        placeholder="Nombre de usuario"
        required
      />
    </div>
    <div>
      <label for="password">Contraseña:</label>
      <input
        type="password"
        name="contrasena"
        [(ngModel)]="contrasena"
        placeholder="Contraseña"
        required
      />
    </div>
    <div>
      <button type="submit">Ingresar</button>
    </div>
    <p *ngIf="mensajeError" style="color: red">{{ mensajeError }}</p>
  </form>
</div>
